import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

/*System */
import Rol from '../components/System/Rol.vue'
import Login from  '../components/System/Login.vue'

/* Defect System*/
import Issue from '../components/Dell/QIN/Issue'
import GetPicture from '../components/Dell/QIN/AppCamara/GetPicture'

/* YMS Invoice*/
import Invoice from '../components/Customs/YMS/Invoice.vue'

/* DELL*/
import PaperPilot from '../components/Dell/PaperPilot/PaperPilot.vue'
import ModProjectDell from '../components/Dell/Mod/ModProjectDell.vue'

/* PE */
import MaterialGroup from '../components/Dell/Mod/MaterialGroup.vue'
import AlternativePN from '../components/Dell/Mod/AlternativePN.vue'
import ModProjectPE from '../components/Dell/Mod/ModProjectPE.vue'


/* 2021 ISG Digitize SOP */
import Contact from '../components/Dell/SOP/Contact.vue'
import AreaSOP from '../components/Dell/SOP/AreaSOP.vue'
import LineSOP from '../components/Dell/SOP/LineSOP.vue'
import WorkFlowSOP from '../components/Dell/SOP/WorkFlowSOP.vue'
import ProductionSOP from '../components/Dell/SOP/ProductionSOP.vue'
import MESOP from '../components/Dell/SOP/MESOP.vue'
import Dashboard from '../components/Dell/SOP/Dashboard.vue'
import LobSOP from '../components/Dell/SOP/LobSOP.vue'
import Signatures from '../components/Dell/SOP/Signatures.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {     
      administrator_all: true,    
      production_dfms: true,
      ipqc_dfms: true,
      custom_customs: true,
      sap_dell: true,
      pe_dfms: true ,
      me_dfms: true,
      sop_admin_dfms: true
    }
  },
  {
    path: '/Issue',
    name: 'Issue',
    component: Issue,
    meta: {
      administrator_all: true,     
      production_dfms: true,
      ipqc_dfms: true
    }
  },
  {
    path: '/GetPicture',
    name: 'GetPicture',
    component: GetPicture,
    meta: {
      administrator_all: true,     
      production_dfms: true,
      ipqc_dfms: true
    }
  },
  /************************ YMS [ini] **********************************/
  {
    path: '/Invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      administrator_all: true,
      administrator_customs: true,    
      custom_customs: true,
      yms_custom: true      
    }
  },
 /************************ YMS [end] **********************************/

  /************************ DELL [ini] **********************************/
  {
    path: '/PaperPilot',
    name: 'PaperPilot',
    component: PaperPilot,
    meta: {
      administrator_all: true,      
      sap_dell: true,
      paperpilot_dell: true      
    }
  },
  {
    path: '/ModProjectDell',
    name: 'ModProjectDell',
    component: ModProjectDell,
    meta: {
      administrator_all: true,      
      sap_dell: true      
    }
  },
  //************************ DELL [end] **********************************/

  //************************ PE [ini] **********************************/
  {
    path: '/MaterialGroup',
    name: 'MaterialGroup',
    component: MaterialGroup,
    meta: {
      administrator_all: true,      
      pe_dfms: true      
    }
  },
  {
    path: '/AlternativePN',
    name: 'AlternativePN',
    component: AlternativePN,
    meta: {
      administrator_all: true,      
      pe_dfms: true      
    }
  },
  {
    path: '/ModProjectPE',
    name: 'ModProjectPE',
    component: ModProjectPE,
    meta: {
      administrator_all: true,      
      pe_dfms: true      
    }
  },
  //************************ PE [end] **********************************/

   //************************ 2021 ISG Digitize SOP [ini] **********************************/
   {
    path: '/Contact',
    name: 'Contact',
    component: Contact,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/AreaSOP',
    name: 'AreaSOP',
    component: AreaSOP,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/LineSOP',
    name: 'LineSOP',
    component: LineSOP,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/WorkFlowSOP',
    name: 'WorkFlowSOP',
    component: WorkFlowSOP,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/ProductionSOP',
    name: 'ProductionSOP',
    component: ProductionSOP,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true,
      me_dfms: true,
      production_dfms: true      
    }
  },
  {
    path: '/MESOP',
    name: 'MESOP',
    component: MESOP,
    meta: {
      administrator_all: true,
      me_dfms: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/Signatures',
    name: 'Signatures',
    component: Signatures,
    meta: {
      administrator_all: true,
      me_dfms: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      administrator_all: true,
      me_dfms: true,      
      sop_admin_dfms: true      
    }
  },
  {
    path: '/LobSOP',
    name: 'LobSOP',
    component: LobSOP,
    meta: {
      administrator_all: true,      
      sop_admin_dfms: true      
    }
  },
  
   //************************ 2021 ISG Digitize SOP [end] **********************************/
  {
    path: '/Roles',
    name: 'Roles',
    component: Rol,
    meta: {
      administrator_all: true,      
    }
  },
  {
    path: '/Login/:token?',//  '/login',For Doit 2FA,    /Login/:token?/:list?
    name: 'Login',
    component: Login,
    meta:{
      free: true
    }
  },
  {
    path: '/about',
    name: 'About',    
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  
  if (to.matched.some(record => record.meta.free)){
    next() ;  
  }   else if (store.state.user && store.state.user.rol == "administrator_all"){
        if (to.matched.some(record => record.meta.administrator_all)){
          next();
        }
      }
      else if (store.state.user && store.state.user.rol == "production_dfms"){
        if (to.matched.some(record => record.meta.production_dfms)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "ipqc_dfms"){
        if (to.matched.some(record => record.meta.ipqc_dfms)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "pe_dfms"){
        if (to.matched.some(record => record.meta.pe_dfms)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "me_dfms"){
        if (to.matched.some(record => record.meta.me_dfms)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "administrator_customs"){
        if (to.matched.some(record => record.meta.custom_customs)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "custom_customs"){
        if (to.matched.some(record => record.meta.custom_customs)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "yms_customs"){
        if (to.matched.some(record => record.meta.custom_customs)){
          next();
        }      
      }
      else if (store.state.user && store.state.user.rol == "sap_dell"){
        if (to.matched.some(record => record.meta.sap_dell)){
          next();
        }      
      }else if (store.state.user && store.state.user.rol == "paperpilot_dell"){
        if (to.matched.some(record => record.meta.sap_dell)){
          next();
        }      
      }else if (store.state.user && store.state.user.rol == "sop_admin_dfms"){
        if (to.matched.some(record => record.meta.sop_admin_dfms)){
          next();
        }      
      }
      else 
      {
       next('Login')
      }
     
  
 

})

export default router

